export const ACCEPTABLE_LANGUAGES = ["en", "fr"] as const;
export type AcceptableLanguage = (typeof ACCEPTABLE_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: AcceptableLanguage = "en";

export const isAcceptableLanguage = (
  lang: string
): lang is AcceptableLanguage => {
  return ACCEPTABLE_LANGUAGES.includes(lang as AcceptableLanguage);
};
